<template >
  <div name="resourceadd" class="-mx-3 -mt-4">
    <section v-if="errored" class="w-full text-center mt-6">
      <h3 class="font-bold text-xl text-action-red">
        There was an issue adding the resource details.
      </h3>
      <p class="text-action-blue">
        Please try again shortly or contact us to resolve the issue.
      </p>
    </section>

    <div class="w-full mx-auto p-6 pb-10 bg-white rounded-xl z-10">

      <section v-if="isResourceComplete" class="w-full text-center mt-2">
        <h3 class="font-bold text-xl text-action-blue">
          Your file has been uploaded.
        </h3>
        <p class="text-action-blue">
          The uploaded resource can be viewed within the video library.
        </p>
        <button
          @click="refreshUpload()"
          type="button"
          class="publish-button hover:bg-blue-300 mt-4"
        >
          Upload another video
        </button>
      </section>

      <form
        class="space-y-2 px-4"
        v-on:submit.prevent="submitUpload"
        ref="form"
      >
      <div
          class="grid grid-cols-1 space-y-2 pt-3"
          v-if="displayKey != undefined"
        >
          <label class="text-sm font-bold text-gray-600 text-left tracking-wide"
            >Video Type</label
          >

          <div class="flex flex-wrap mb-8">
            <button
              type="button"
              class="mr-3 mb-2 rounded p-2 px-6 cursor-pointer hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue font-bold icon fa-check"
              v-bind:class="[
                selectedType === 'youtube'
                  ? 'bg-gray-500 text-white'
                  : 'bg-gray-200 text-gray-600',
              ]"
              @click="selectedType = 'youtube'"
            >
              YouTube
            </button>

            <button
            v-if="hasVideoAdmin"
              type="button"
              class="mr-3 mb-2 rounded p-2 px-6 cursor-pointer hover:bg-gray-400 hover:bg-opacity-50 hover:text-action-blue font-bold icon fa-check"
              v-bind:class="[
                selectedType === 'pepa'
                  ? 'bg-gray-500  text-white'
                  : 'bg-gray-200 text-gray-600',
              ]"
              @click="selectedType = 'pepa'"
            >
              Custom
            </button>
          </div>
        </div>


        <div class="grid grid-cols-1 space-y-2">
          <label class="text-sm font-bold text-gray-600 text-left tracking-wide"
            >Video Title</label
          >
          <input
            class="p-3 mb-5 bg-white border border-gray-200 rounded h-36 focus:bg-white focus:outline-none"
            type=""
            v-model="title"
            placeholder="Enter title..."
          />
        </div>

      <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-200">
          <label class="font-semibold pb-2 text-gray-600">Category</label>
          <div class="w-2/3">
            <dropdown
                :options="catDropdown"
                :selected="selectedCategory"
                id="grid-category"
                v-on:updateOption="catSelect"
                mode="form"
                class="bg-gray-100"
              ></dropdown>
      
        </div>
      </div>

        <div class="grid grid-cols-1 space-y-2 py-4">
          <label class="text-sm font-bold text-gray-600 text-left tracking-wide"
            >Service URL A</label
          >
          <input
            class="p-3 mb-5 bg-white border border-gray-200 rounded h-36 focus:bg-white focus:outline-none"
            type=""
            v-model="serviceUrlA"
            placeholder="Enter url..."
          />
        </div>

        <div class="grid grid-cols-1 space-y-2">
          <label class="text-sm font-bold text-gray-600 text-left tracking-wide"
            >Service URL B (optional)</label
          >
          <input
            class="p-3 mb-5 bg-white border border-gray-200 rounded h-36 focus:bg-white focus:outline-none"
            type=""
            v-model="serviceUrlB"
            @change="parseVideoB"
            placeholder="Enter url..."
          />
        </div>

        <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-200 mr-6">
          
          <div class="font-semibold flex justify-between w-ful pb-4 text-gray-600">Tags
                    <div class="flex"> 
                      <div class="bg-blue-500 tag-example mr-2 w-10"
                      @click="addTags('sen')">#sen</div>

                      <div class="bg-orange-500 tag-example"
                      @click="addTags('ofsted')">#ofsted</div>
                    </div>
                    
                  </div>
                  <input
                v-model="tags"
                class="p-1"
                type="text"
                placeholder="Enter tags..."
              />
      </div>


        <div>
          <button
            @click="submitForm()"
            type="submit"
            class="publish-button hover:opacity-50 my-5 w-full flex justify-center p-4 tracking-wide focus:outline-none focus:shadow-outline shadow-lg cursor-pointer transition ease-in duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="!hasUrl"
          >
            Upload
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { BaseService, SchoolService } from "@/services/school.service";
const Dropdown = () => import("@/components/Dropdown.vue");

export default {
  name: "resourceadd",
  mixins: [],
  props: {
    course: { type: Object, required: false },
    lesson: { type: Object, required: false },
    displayKey: { type: String, required: false },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings",
    }),
    hasUrl() {
      return this.serviceUrlA.length > 3 && this.title.length > 3;
    },
    hasVideoAdmin() {
      return this.currentUser.isContentAdmin || this.currentUser.isOrganisation;
    },
    catDropdown() {
      var results = [{ id: 0, name: "Select a category" }].concat(this.cats);
      if (this.selectedCategory === undefined) {
        this.selectedCategory = results[0];
      }
      return results;
    },
  },
  data() {
    return {
      school: this.$store.getters.school,
      errored: false,
      isResourceComplete: false,
      cats: [],
      title: "",
      serviceUrlA: "",
      serviceUrlB: "",
      selectedType: "youtube",
      tags: "",
      selectedCategory: {}
    };

  },
  created() {
        // cats
        BaseService.getAll("categories")
      .then((response) => this.cats = response.data.data)
      .catch((res) => {
        console.log(res);
      });
  },
  mounted() {

  },
  methods: {
    catSelect(cat) {
      this.selectedCategory = cat;
    },
    submitUpload() {
      let cat = this.selectedCategory.id > 0 ? this.selectedCategory.id : null
      let serviceB = this.serviceUrlB.length > 0 ? this.serviceUrlB : this.serviceUrlA
      let key = this.displayKey != undefined ? this.displayKey : "library"

      var vm = this;
      var payload = {
        service_type: this.selectedType,
        display_key: key,
        service_url_a: this.serviceUrlA,
        service_url_b: serviceB,
        display_order: 0,
        active: 1,
        title: this.title,
        tags: this.tags,
        category_id: cat
      };

      if (this.lesson != undefined) {
        payload.video_lessons = [
          {
            lesson_id: this.lesson.id,
          },
        ];
      } else if (this.course != undefined) {
        payload.video_units = [
          {
            course_id: this.course.id,
          },
        ];
      }

      SchoolService.create("videos", payload)
        .then((response) => {
          vm.completion();
        })
        .catch((err) => {
          this.failure(err);
        });
    },
    submitForm() {
      if (this.$refs.form.requestSubmit === undefined) {
        this.submitUpload();
      } else {
        this.$refs.form.requestSubmit();
      }
    },
    completion(response) {
      this.isResourceComplete = true;
      this.$emit("resource-added");
      window.scrollTo(0, 0);
    },
    failure(error) {
      this.isResourceComplete = false;
      this.errored = true;
      console.log("Resource update error " + error);
    },
    parseVideoB() {
      this.serviceUrlB = this.serviceUrlB.replace("<iframe class='sproutvideo-player' src='", "")
      this.serviceUrlB = this.serviceUrlB.replace("?autoPlay=true&amp;playerTheme=dark&amp;playerColor=' width='640' height='360' frameborder='0' allowfullscreen referrerpolicy='no-referrer-when-downgrade' title='Video Player'></iframe>", "")
    }
  },
  components: {
    Dropdown
  },
};
</script>

<style scoped>
.section-head {
  @apply text-xl m-5 ml-0 font-bold text-orange-500;
}

.boxer {
  @apply mb-8 bg-gray-100 py-3 rounded border border-gray-300;
}

.boxer-header {
  @apply block uppercase tracking-wide text-blue-700 text-sm font-bold mb-3;
}
</style>